import styled from 'styled-components';
import { textblocks } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';
import { theme } from '@Themes/themeOverriderFabric';

const { texts, colors, spaces } = getBaseTheme();

export const AnalyticDiv = styled.div`
    cursor: pointer;
    padding: ${spaces.default.xxxs};
    margin-top: ${spaces.default.xxs};
    background-color: ${props => props.highlighted && `${theme.palette.blueHighlight}`};
`;

export const ErrorText = styled(textblocks.Label)`
    ${texts.sizes.xs};
    padding: ${spaces.default.xxs};
    color: ${colors.control.error.complementaryForegroundColor};
`;
